var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CrossWindowServer from '../messaging/server';
/**
 * Handles to cross window request for the order
 */
export default class CrossWindowOrder extends CrossWindowServer {
    constructor(_window, _order) {
        super(_order, {
            window: _window,
            scope: 'order',
        });
        this.order = _order;
        // Listen for all events in the order scope
        this.order.on('order', () => this._updateOrderData());
    }
    /**
     * Handle incoming messages
     * @param event - Received message
     */
    onClientMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = event.data.data;
            // TODO: handle all cases
        });
    }
    /**
     * Send a update message containing the order data
     */
    _updateOrderData() {
        this._sendMessage({
            action: 'update',
            data: JSON.parse(JSON.stringify(this.order.data || {})),
        });
    }
}
//# sourceMappingURL=messaging.js.map